import { render, staticRenderFns } from "./MoreOptionsItem.vue?vue&type=template&id=1979d2e8&scoped=true"
import script from "./MoreOptionsItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./MoreOptionsItem.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MoreOptionsItem.vue?vue&type=style&index=0&id=1979d2e8&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1979d2e8",
  null
  
)

export default component.exports